import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/icd-medication-request-form";

export const pagingICDCodeMedicationRequestForm = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getICDCodeMedicationRequestFormById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdate = iCDCodeMedicationRequestForm => axios.post(API_PATH + '/save', iCDCodeMedicationRequestForm);

export const deleteICDCodeMedicationRequestForm = id => axios.delete(API_PATH + '/mark-delete/' + id);

export const getAllICDCodeMedicationRequestForms = () => axios.get(API_PATH + "/get-all")

export const getListMediReqByListICD = dto => axios.post(API_PATH + "/get-list-medi-req-by-list-icd", dto)
